import styled from 'styled-components';

const InputFocusWrapper = styled.div`
  :focus-within {
    border: 1px solid #54a300;
  }
`;

export default InputFocusWrapper;
